'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var globalId = 0;

var HubspotForm = function (_React$Component) {
  _inherits(HubspotForm, _React$Component);

  function HubspotForm(props) {
    _classCallCheck(this, HubspotForm);

    var _this = _possibleConstructorReturn(this, (HubspotForm.__proto__ || Object.getPrototypeOf(HubspotForm)).call(this, props));

    _this.state = {
      loaded: false
    };
    _this.id = globalId++;
    _this.createForm = _this.createForm.bind(_this);
    _this.findFormElement = _this.findFormElement.bind(_this);
    return _this;
  }

  _createClass(HubspotForm, [{
    key: 'createForm',
    value: function createForm() {
      var _this2 = this;

      if (window.hbspt) {
        // protect against component unmounting before window.hbspt is available
        if (this.el === null) {
          return;
        }

        var props = _extends({}, this.props);

        delete props.loading;
        delete props.onSubmit;
        delete props.onReady;

        var options = _extends({}, props, {
          target: '#' + this.el.getAttribute('id'),
          onFormSubmit: function onFormSubmit($form) {
            // ref: https://developers.hubspot.com/docs/methods/forms/advanced_form_options
            var formData = $form.serializeArray();

            _this2.props.onSubmit(formData);
          }
        });

        window.hbspt.forms.create(options);
        return true;
      } else {
        setTimeout(this.createForm, 1);
      }
    }
  }, {
    key: 'loadScript',
    value: function loadScript() {
      var _this3 = this;

      var script = document.createElement('script');
      script.defer = true;

      script.onload = function () {
        _this3.createForm();

        _this3.findFormElement();
      };

      script.src = '//js.hsforms.net/forms/v2.js';
      document.head.appendChild(script);
    }
  }, {
    key: 'findFormElement',
    value: function findFormElement() {
      // protect against component unmounting before form is added
      if (this.el === null) {
        return;
      }

      var form = this.el.querySelector('iframe');

      if (form) {
        this.setState({
          loaded: true
        });

        if (this.props.onReady) {
          this.props.onReady(form);
        }
      } else {
        setTimeout(this.findFormElement, 1);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!window.hbspt && !this.props.noScript) {
        this.loadScript();
      } else {
        this.createForm();
        this.findFormElement();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement('div', null, _react2.default.createElement('div', {
        ref: function ref(el) {
          return _this4.el = el;
        },
        id: 'reactHubspotForm' + this.id,
        style: {
          display: this.state.loaded ? 'block' : 'none'
        }
      }), !this.state.loaded && this.props.loading);
    }
  }]);

  return HubspotForm;
}(_react2.default.Component);

exports.default = HubspotForm;
module.exports = exports['default'];